import styled, { css } from 'styled-components';
import { StyledWarehouseProductCardListProps } from './types';

export const StyledWarehouseProductCardList = styled.ul<StyledWarehouseProductCardListProps>`
  ${({ isHorizontal }) =>
    isHorizontal
      ? css`
          width: 100%;
        `
      : css`
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
          gap: var(--s-4);
        `};
`;

export const StyledWarehouseProductCardListItem = styled.li<StyledWarehouseProductCardListProps>`
  ${({ isHorizontal }) =>
    isHorizontal &&
    css`
      &:not(:last-child) {
        margin-bottom: var(--s-2);
      }
    `}
`;

export const ProductsPlaceholderWrapper = styled.div`
  > div {
    margin: 0;

    h3 {
      text-align: start;
    }
  }
`;
